module.exports = __webpack_public_path__ + "static/media/google_icon.18d69cce.svg";